// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Account from "./account.js"
import Contact from "./contact.js"
import Country from "./country.js"
import Currency from "./currency.js"
import Dialogue from "./dialogue.js"
import Locale from "./locale.js"
import NotificationSetting from "./notification-setting.js"
import School from "./school.js"
import SchoolClass from "./school-class.js"
import Subscription from "./subscription.js"
import UserAudit from "./user-audit.js"
import UserRole from "./user-role.js"

const modelClassData = {
  "attributes": {
    "account_users_count": {
      "column": {
        "default": "0",
        "name": "account_users_count",
        "null": false,
        "type": "integer"
      },
      "name": "account_users_count",
      "selected_by_default": null,
      "translated": null
    },
    "color": {
      "column": {
        "default": null,
        "name": "color",
        "null": true,
        "type": "string"
      },
      "name": "color",
      "selected_by_default": null,
      "translated": null
    },
    "conference_mode_in_woofs_closing_with_delay_after_24_hours": {
      "column": {
        "default": "0",
        "name": "conference_mode_in_woofs_closing_with_delay_after_24_hours",
        "null": false,
        "type": "boolean"
      },
      "name": "conference_mode_in_woofs_closing_with_delay_after_24_hours",
      "selected_by_default": null,
      "translated": null
    },
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": null
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "currency_id": {
      "column": {
        "default": null,
        "name": "currency_id",
        "null": true,
        "type": null
      },
      "name": "currency_id",
      "selected_by_default": null,
      "translated": null
    },
    "current_country_id": {
      "column": {
        "default": null,
        "name": "current_country_id",
        "null": true,
        "type": null
      },
      "name": "current_country_id",
      "selected_by_default": null,
      "translated": null
    },
    "email": {
      "column": null,
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "first_name": {
      "column": null,
      "name": "first_name",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "initials": {
      "column": {
        "default": null,
        "name": "initials",
        "null": true,
        "type": "string"
      },
      "name": "initials",
      "selected_by_default": null,
      "translated": null
    },
    "last_activity_at": {
      "column": {
        "default": null,
        "name": "last_activity_at",
        "null": true,
        "type": "datetime"
      },
      "name": "last_activity_at",
      "selected_by_default": null,
      "translated": null
    },
    "last_name": {
      "column": null,
      "name": "last_name",
      "selected_by_default": null,
      "translated": null
    },
    "locale": {
      "column": {
        "default": null,
        "name": "locale",
        "null": false,
        "type": "string"
      },
      "name": "locale",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "phone_number": {
      "column": null,
      "name": "phone_number",
      "selected_by_default": null,
      "translated": null
    },
    "seen_dashboard_first_visit_upgrade_overlay": {
      "column": {
        "default": "0",
        "name": "seen_dashboard_first_visit_upgrade_overlay",
        "null": false,
        "type": "boolean"
      },
      "name": "seen_dashboard_first_visit_upgrade_overlay",
      "selected_by_default": null,
      "translated": null
    },
    "school_class_check_ins_count": {
      "column": {
        "default": "0",
        "name": "school_class_check_ins_count",
        "null": false,
        "type": "integer"
      },
      "name": "school_class_check_ins_count",
      "selected_by_default": null,
      "translated": null
    },
    "sign_in_count": {
      "column": {
        "default": "0",
        "name": "sign_in_count",
        "null": false,
        "type": "integer"
      },
      "name": "sign_in_count",
      "selected_by_default": null,
      "translated": null
    },
    "subscriptions_count": {
      "column": {
        "default": "0",
        "name": "subscriptions_count",
        "null": false,
        "type": "integer"
      },
      "name": "subscriptions_count",
      "selected_by_default": null,
      "translated": null
    },
    "time_zone_offset": {
      "column": {
        "default": null,
        "name": "time_zone_offset",
        "null": true,
        "type": "integer"
      },
      "name": "time_zone_offset",
      "selected_by_default": null,
      "translated": null
    },
    "unconfirmed_email": {
      "column": {
        "default": null,
        "name": "unconfirmed_email",
        "null": true,
        "type": "string"
      },
      "name": "unconfirmed_email",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "user_roles_count": {
      "column": {
        "default": "0",
        "name": "user_roles_count",
        "null": false,
        "type": "integer"
      },
      "name": "user_roles_count",
      "selected_by_default": null,
      "translated": null
    },
    "identified_roles": {
      "column": null,
      "name": "identified_roles",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "User",
  "collectionKey": "users",
  "collectionName": "users",
  "i18nKey": "user",
  "camelizedLower": "user",
  "name": "User",
  "nameDasherized": "user",
  "pluralName": "users",
  "ransackable_associations": [
    {
      "className": "SchoolClassInvitation",
      "collectionName": "school_class_invitations",
      "foreignKey": "existing_user_id",
      "name": "accepted_invitations",
      "macro": "has_many",
      "resource_name": "SchoolClassInvitation",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "account_manager_id",
      "name": "account_manager_for",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "AccountUser",
      "collectionName": "account_users",
      "foreignKey": "user_id",
      "name": "account_users",
      "macro": "has_many",
      "resource_name": "AccountUser",
      "through": null
    },
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "account_id",
      "name": "accounts",
      "macro": "has_many",
      "resource_name": "Account",
      "through": "account_users"
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "active_subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": "contact"
    },
    {
      "className": "User::Audit",
      "collectionName": "user_audits",
      "foreignKey": "user_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "UserAudit",
      "through": null
    },
    {
      "className": "ClassStatusExpansion",
      "collectionName": "class_status_expansions",
      "foreignKey": "user_id",
      "name": "class_status_expansion",
      "macro": "has_many",
      "resource_name": "ClassStatusExpansion",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "User::Audit",
      "collectionName": "user_audits",
      "foreignKey": "user_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "UserAudit",
      "through": null
    },
    {
      "className": "SchoolClassInvitation",
      "collectionName": "school_class_invitations",
      "foreignKey": "created_user_id",
      "name": "created_by_invitation",
      "macro": "has_one",
      "resource_name": "SchoolClassInvitation",
      "through": null
    },
    {
      "className": "Currency",
      "collectionName": "currencies",
      "foreignKey": "currency_id",
      "name": "currency",
      "macro": "belongs_to",
      "resource_name": "Currency",
      "through": null
    },
    {
      "className": "Country",
      "collectionName": "countries",
      "foreignKey": "country_id",
      "name": "current_country",
      "macro": "has_one",
      "resource_name": "Country",
      "through": "contact"
    },
    {
      "className": "WorkerPlugins::Workplace",
      "collectionName": "workplaces",
      "foreignKey": "current_workplace_id",
      "name": "current_workplace",
      "macro": "belongs_to",
      "resource_name": "Workplace",
      "through": null
    },
    {
      "className": "Dialogue",
      "collectionName": "dialogues",
      "foreignKey": "contact_id",
      "name": "dialogues",
      "macro": "has_many",
      "resource_name": "Dialogue",
      "through": "contact"
    },
    {
      "className": "SchoolClassInvitation",
      "collectionName": "school_class_invitations",
      "foreignKey": "invited_by_user_id",
      "name": "invited_school_class_invitations",
      "macro": "has_many",
      "resource_name": "SchoolClassInvitation",
      "through": null
    },
    {
      "className": "Dialogue",
      "collectionName": "dialogues",
      "foreignKey": "contact_id",
      "name": "latest_dialogue",
      "macro": "has_one",
      "resource_name": "Dialogue",
      "through": "contact"
    },
    {
      "className": "Locale",
      "collectionName": "locales",
      "foreignKey": "locale",
      "name": "locale_model",
      "macro": "belongs_to",
      "resource_name": "Locale",
      "through": null
    },
    {
      "className": "Newsletter",
      "collectionName": "newsletters",
      "foreignKey": "user_id",
      "name": "newsletters",
      "macro": "has_many",
      "resource_name": "Newsletter",
      "through": null
    },
    {
      "className": "NotificationSetting",
      "collectionName": "notification_settings",
      "foreignKey": "user_id",
      "name": "notification_setting",
      "macro": "has_one",
      "resource_name": "NotificationSetting",
      "through": null
    },
    {
      "className": "Notification",
      "collectionName": "notifications",
      "foreignKey": "user_id",
      "name": "notifications",
      "macro": "has_many",
      "resource_name": "Notification",
      "through": null
    },
    {
      "className": "PageView",
      "collectionName": "page_views",
      "foreignKey": "user_id",
      "name": "page_views",
      "macro": "has_many",
      "resource_name": "PageView",
      "through": null
    },
    {
      "className": "Role",
      "collectionName": "roles",
      "foreignKey": "role_id",
      "name": "roles",
      "macro": "has_many",
      "resource_name": "Role",
      "through": "user_roles"
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_check_in_id",
      "name": "school_class_check_in",
      "macro": "belongs_to",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "user_id",
      "name": "school_class_check_ins",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "school_class_contact_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": "contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "school_class_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "school_class_contact_relationships"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "contact_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "school_class_contacts"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "school_contact_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": "contact"
    },
    {
      "className": "SchoolContactRequest",
      "collectionName": "school_contact_requests",
      "foreignKey": "user_id",
      "name": "school_contact_requests",
      "macro": "has_many",
      "resource_name": "SchoolContactRequest",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "school_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "school_contact_relationships"
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "schools",
      "macro": "has_many",
      "resource_name": "School",
      "through": "school_contacts"
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "schools_through_classes",
      "macro": "has_many",
      "resource_name": "School",
      "through": "school_classes"
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": "contact"
    },
    {
      "className": "ApiMakerTable::TableSearch",
      "collectionName": "table_searches",
      "foreignKey": "user_id",
      "name": "table_searches",
      "macro": "has_many",
      "resource_name": "TableSearch",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "teacher_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "contact"
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "contact_id",
      "name": "teachers",
      "macro": "has_many",
      "resource_name": "User",
      "through": "teacher_contacts"
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "user_id",
      "name": "team_users",
      "macro": "has_many",
      "resource_name": "TeamUser",
      "through": null
    },
    {
      "className": "UserRole",
      "collectionName": "user_roles",
      "foreignKey": "user_id",
      "name": "user_roles",
      "macro": "has_many",
      "resource_name": "UserRole",
      "through": null
    },
    {
      "className": "WorkerPlugins::Workplace",
      "collectionName": "workplaces",
      "foreignKey": "user_id",
      "name": "workplaces",
      "macro": "has_many",
      "resource_name": "Workplace",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "account_users_count",
      "column": {
        "default": "0",
        "name": "account_users_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "anonymous",
      "column": {
        "default": "0",
        "name": "anonymous",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "color",
      "column": {
        "default": null,
        "name": "color",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "conference_mode_in_woofs_closing_with_delay_after_24_hours",
      "column": {
        "default": "0",
        "name": "conference_mode_in_woofs_closing_with_delay_after_24_hours",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "confirmation_sent_at",
      "column": {
        "default": null,
        "name": "confirmation_sent_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "confirmation_token",
      "column": {
        "default": null,
        "name": "confirmation_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "confirmed_at",
      "column": {
        "default": null,
        "name": "confirmed_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "currency_id",
      "column": {
        "default": null,
        "name": "currency_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "current_country_id",
      "column": {
        "default": null,
        "name": "current_country_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "current_sign_in_at",
      "column": {
        "default": null,
        "name": "current_sign_in_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "current_sign_in_ip",
      "column": {
        "default": null,
        "name": "current_sign_in_ip",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "current_workplace_id",
      "column": {
        "default": null,
        "name": "current_workplace_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "encrypted_password",
      "column": {
        "default": "",
        "name": "encrypted_password",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "failed_attempts",
      "column": {
        "default": "0",
        "name": "failed_attempts",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "initials",
      "column": {
        "default": null,
        "name": "initials",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "last_activity_at",
      "column": {
        "default": null,
        "name": "last_activity_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "last_sign_in_at",
      "column": {
        "default": null,
        "name": "last_sign_in_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "last_sign_in_ip",
      "column": {
        "default": null,
        "name": "last_sign_in_ip",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "locale",
      "column": {
        "default": null,
        "name": "locale",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "locked_at",
      "column": {
        "default": null,
        "name": "locked_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "remember_created_at",
      "column": {
        "default": null,
        "name": "remember_created_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "reset_password_sent_at",
      "column": {
        "default": null,
        "name": "reset_password_sent_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "reset_password_token",
      "column": {
        "default": null,
        "name": "reset_password_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "school_class_check_in_id",
      "column": {
        "default": null,
        "name": "school_class_check_in_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "school_class_check_ins_count",
      "column": {
        "default": "0",
        "name": "school_class_check_ins_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "seen_dashboard_first_visit_upgrade_overlay",
      "column": {
        "default": "0",
        "name": "seen_dashboard_first_visit_upgrade_overlay",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "sign_in_count",
      "column": {
        "default": "0",
        "name": "sign_in_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "subscriptions_count",
      "column": {
        "default": "0",
        "name": "subscriptions_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "time_zone_name",
      "column": {
        "default": null,
        "name": "time_zone_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "time_zone_offset",
      "column": {
        "default": null,
        "name": "time_zone_offset",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "unconfirmed_email",
      "column": {
        "default": null,
        "name": "unconfirmed_email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "unlock_token",
      "column": {
        "default": null,
        "name": "unlock_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_roles_count",
      "column": {
        "default": "0",
        "name": "user_roles_count",
        "null": false,
        "type": "integer"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "associated_with_school_ids"
    },
    {
      "name": "email_eq"
    },
    {
      "name": "teachers"
    },
    {
      "name": "teachers_that_hasnt_woofed"
    },
    {
      "name": "teachers_that_hasnt_woofed_this_year"
    },
    {
      "name": "teachers_that_have_woofed"
    },
    {
      "name": "with_any_pro_subscription"
    },
    {
      "name": "with_class_and_one_woof_this_week"
    },
    {
      "name": "with_role"
    },
    {
      "name": "without_any_pro_subscription"
    },
    {
      "name": "without_roles"
    }
  ],
  "relationships": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "account_id",
      "name": "accounts",
      "macro": "has_many",
      "resource_name": "Account",
      "through": "account_users"
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "active_subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": "contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "User::Audit",
      "collectionName": "user_audits",
      "foreignKey": "user_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "UserAudit",
      "through": null
    },
    {
      "className": "Currency",
      "collectionName": "currencies",
      "foreignKey": "currency_id",
      "name": "currency",
      "macro": "belongs_to",
      "resource_name": "Currency",
      "through": null
    },
    {
      "className": "Country",
      "collectionName": "countries",
      "foreignKey": "country_id",
      "name": "current_country",
      "macro": "has_one",
      "resource_name": "Country",
      "through": "contact"
    },
    {
      "className": "Dialogue",
      "collectionName": "dialogues",
      "foreignKey": "contact_id",
      "name": "latest_dialogue",
      "macro": "has_one",
      "resource_name": "Dialogue",
      "through": "contact"
    },
    {
      "className": "Locale",
      "collectionName": "locales",
      "foreignKey": "locale",
      "name": "locale_model",
      "macro": "belongs_to",
      "resource_name": "Locale",
      "through": null
    },
    {
      "className": "NotificationSetting",
      "collectionName": "notification_settings",
      "foreignKey": "user_id",
      "name": "notification_setting",
      "macro": "has_one",
      "resource_name": "NotificationSetting",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "contact_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "school_class_contacts"
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "schools",
      "macro": "has_many",
      "resource_name": "School",
      "through": "school_contacts"
    },
    {
      "className": "UserRole",
      "collectionName": "user_roles",
      "foreignKey": "user_id",
      "name": "user_roles",
      "macro": "has_many",
      "resource_name": "UserRole",
      "through": null
    }
  ],
  "paramKey": "user",
  "primaryKey": "id"
}

/** Frontend model for User. */
export default class User extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number} */
  accountUsersCount() {
    return this.readAttributeUnderscore("account_users_count")
  }

  /** @returns {boolean} */
  hasAccountUsersCount() {
    const value = this.accountUsersCount()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  color() {
    return this.readAttributeUnderscore("color")
  }

  /** @returns {boolean} */
  hasColor() {
    const value = this.color()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  conferenceModeInWoofsClosingWithDelayAfter24Hours() {
    return this.readAttributeUnderscore("conference_mode_in_woofs_closing_with_delay_after_24_hours")
  }

  /** @returns {boolean} */
  hasConferenceModeInWoofsClosingWithDelayAfter24Hours() {
    const value = this.conferenceModeInWoofsClosingWithDelayAfter24Hours()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  currencyId() {
    return this.readAttributeUnderscore("currency_id")
  }

  /** @returns {boolean} */
  hasCurrencyId() {
    const value = this.currencyId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  currentCountryId() {
    return this.readAttributeUnderscore("current_country_id")
  }

  /** @returns {boolean} */
  hasCurrentCountryId() {
    const value = this.currentCountryId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {any} */
  firstName() {
    return this.readAttributeUnderscore("first_name")
  }

  /** @returns {boolean} */
  hasFirstName() {
    const value = this.firstName()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  initials() {
    return this.readAttributeUnderscore("initials")
  }

  /** @returns {boolean} */
  hasInitials() {
    const value = this.initials()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  lastActivityAt() {
    return this.readAttributeUnderscore("last_activity_at")
  }

  /** @returns {boolean} */
  hasLastActivityAt() {
    const value = this.lastActivityAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  lastName() {
    return this.readAttributeUnderscore("last_name")
  }

  /** @returns {boolean} */
  hasLastName() {
    const value = this.lastName()

    return this._isPresent(value)
  }

  /** @returns {string} */
  locale() {
    return this.readAttributeUnderscore("locale")
  }

  /** @returns {boolean} */
  hasLocale() {
    const value = this.locale()

    return this._isPresent(value)
  }

  /** @returns {any} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  phoneNumber() {
    return this.readAttributeUnderscore("phone_number")
  }

  /** @returns {boolean} */
  hasPhoneNumber() {
    const value = this.phoneNumber()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  seenDashboardFirstVisitUpgradeOverlay() {
    return this.readAttributeUnderscore("seen_dashboard_first_visit_upgrade_overlay")
  }

  /** @returns {boolean} */
  hasSeenDashboardFirstVisitUpgradeOverlay() {
    const value = this.seenDashboardFirstVisitUpgradeOverlay()

    return this._isPresent(value)
  }

  /** @returns {number} */
  schoolClassCheckInsCount() {
    return this.readAttributeUnderscore("school_class_check_ins_count")
  }

  /** @returns {boolean} */
  hasSchoolClassCheckInsCount() {
    const value = this.schoolClassCheckInsCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  signInCount() {
    return this.readAttributeUnderscore("sign_in_count")
  }

  /** @returns {boolean} */
  hasSignInCount() {
    const value = this.signInCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  subscriptionsCount() {
    return this.readAttributeUnderscore("subscriptions_count")
  }

  /** @returns {boolean} */
  hasSubscriptionsCount() {
    const value = this.subscriptionsCount()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  timeZoneOffset() {
    return this.readAttributeUnderscore("time_zone_offset")
  }

  /** @returns {boolean} */
  hasTimeZoneOffset() {
    const value = this.timeZoneOffset()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  unconfirmedEmail() {
    return this.readAttributeUnderscore("unconfirmed_email")
  }

  /** @returns {boolean} */
  hasUnconfirmedEmail() {
    const value = this.unconfirmedEmail()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {number} */
  userRolesCount() {
    return this.readAttributeUnderscore("user_roles_count")
  }

  /** @returns {boolean} */
  hasUserRolesCount() {
    const value = this.userRolesCount()

    return this._isPresent(value)
  }

  /** @returns {any} */
  identifiedRoles() {
    return this.readAttributeUnderscore("identified_roles")
  }

  /** @returns {boolean} */
  hasIdentifiedRoles() {
    const value = this.identifiedRoles()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static applyForgottenPasswordRequest(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "apply_forgotten_password_request",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static confirmEmail(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "confirm_email",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static createUser(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "create_user",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static errorTest(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "error_test",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static liquidDrops(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "liquid_drops",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static profileSave(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "profile_save",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static requestNewPassword(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "request_new_password",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static resendConfirmationEmail(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "resend_confirmation_email",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static setLocale(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "set_locale",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static stateEvent(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "state_event",
        collectionName: "users",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  createAccount(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "create_account",
        primaryKey: this.primaryKey(),
        collectionName: "users",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  deleteProfile(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "delete_profile",
        primaryKey: this.primaryKey(),
        collectionName: "users",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  signInAs(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "sign_in_as",
        primaryKey: this.primaryKey(),
        collectionName: "users",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  weekBar(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "week_bar",
        primaryKey: this.primaryKey(),
        collectionName: "users",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./account.js").default>} */
  accounts() {
    return new Collection(
      {
        reflectionName: "accounts",
        model: this,
        modelClass: Account
      },
      {
        params: {
          through: {
            model: "User",
            id: this.primaryKey(),
            reflection: "accounts"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./account.js").default>>} */
  loadAccounts() {
    return this._loadHasManyReflection(
      {
        reflectionName: "accounts",
        model: this,
        modelClass: Account
      },
      {
        params: {
          through: {
            model: "User",
            id: this.primaryKey(),
            reflection: "accounts"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./account.js").default>>} */
  ensureAccountsLoaded() {
    return this.ensureAssociationLoaded("accounts")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./subscription.js").default>} */
  activeSubscriptions() {
    return new Collection(
      {
        reflectionName: "active_subscriptions",
        model: this,
        modelClass: Subscription
      },
      {
        params: {
          through: {
            model: "User",
            id: this.primaryKey(),
            reflection: "active_subscriptions"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./subscription.js").default>>} */
  loadActiveSubscriptions() {
    return this._loadHasManyReflection(
      {
        reflectionName: "active_subscriptions",
        model: this,
        modelClass: Subscription
      },
      {
        params: {
          through: {
            model: "User",
            id: this.primaryKey(),
            reflection: "active_subscriptions"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./subscription.js").default>>} */
  ensureActiveSubscriptionsLoaded() {
    return this.ensureAssociationLoaded("active_subscriptions")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./user-audit.js").default | null} */
  createAudit() {
    return this._readHasOneReflection({modelClass: UserAudit, reflectionName: "create_audit"})
  }

  /** @returns {Promise<import("./user-audit.js").default | null>} */
  loadCreateAudit() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["user_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "create_audit",
        model: this,
        modelClass: UserAudit
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user-audit.js").default | null>} */
  ensureCreateAuditLoaded() {
    return this.ensureAssociationLoaded("create_audit")
  }

  /** @returns {import("./currency.js").default | null} */
  currency() {
    return this._readBelongsToReflection({modelClass: Currency, reflectionName: "currency"})
  }

  /** @returns {Promise<import("./currency.js").default | null>} */
  loadCurrency() {
    if (!("currencyId" in this)) throw new Error("Foreign key method wasn't defined: currencyId")

    const id = this.currencyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "currency",
        model: this,
        modelClass: Currency
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./currency.js").default | null>} */
  ensureCurrencyLoaded() {
    return this.ensureAssociationLoaded("currency")
  }

  /** @returns {import("./country.js").default | null} */
  currentCountry() {
    return this._readHasOneReflection({modelClass: Country, reflectionName: "current_country"})
  }

  /** @returns {Promise<import("./country.js").default | null>} */
  loadCurrentCountry() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "current_country",
        model: this,
        modelClass: Country
      },
      {
        params: {
          through: {
            model: "User",
            id,
            reflection: "current_country"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./country.js").default | null>} */
  ensureCurrentCountryLoaded() {
    return this.ensureAssociationLoaded("current_country")
  }

  /** @returns {import("./dialogue.js").default | null} */
  latestDialogue() {
    return this._readHasOneReflection({modelClass: Dialogue, reflectionName: "latest_dialogue"})
  }

  /** @returns {Promise<import("./dialogue.js").default | null>} */
  loadLatestDialogue() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "latest_dialogue",
        model: this,
        modelClass: Dialogue
      },
      {
        params: {
          through: {
            model: "User",
            id,
            reflection: "latest_dialogue"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./dialogue.js").default | null>} */
  ensureLatestDialogueLoaded() {
    return this.ensureAssociationLoaded("latest_dialogue")
  }

  /** @returns {import("./locale.js").default | null} */
  localeModel() {
    return this._readBelongsToReflection({modelClass: Locale, reflectionName: "locale_model"})
  }

  /** @returns {Promise<import("./locale.js").default | null>} */
  loadLocaleModel() {
    if (!("locale" in this)) throw new Error("Foreign key method wasn't defined: locale")

    const id = this.locale()
    const ransack = {}

    ransack["locale_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "locale_model",
        model: this,
        modelClass: Locale
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./locale.js").default | null>} */
  ensureLocaleModelLoaded() {
    return this.ensureAssociationLoaded("locale_model")
  }

  /** @returns {import("./notification-setting.js").default | null} */
  notificationSetting() {
    return this._readHasOneReflection({modelClass: NotificationSetting, reflectionName: "notification_setting"})
  }

  /** @returns {Promise<import("./notification-setting.js").default | null>} */
  loadNotificationSetting() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["user_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "notification_setting",
        model: this,
        modelClass: NotificationSetting
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./notification-setting.js").default | null>} */
  ensureNotificationSettingLoaded() {
    return this.ensureAssociationLoaded("notification_setting")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class.js").default>} */
  schoolClasses() {
    return new Collection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "User",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  loadSchoolClasses() {
    return this._loadHasManyReflection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "User",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  ensureSchoolClassesLoaded() {
    return this.ensureAssociationLoaded("school_classes")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school.js").default>} */
  schools() {
    return new Collection(
      {
        reflectionName: "schools",
        model: this,
        modelClass: School
      },
      {
        params: {
          through: {
            model: "User",
            id: this.primaryKey(),
            reflection: "schools"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school.js").default>>} */
  loadSchools() {
    return this._loadHasManyReflection(
      {
        reflectionName: "schools",
        model: this,
        modelClass: School
      },
      {
        params: {
          through: {
            model: "User",
            id: this.primaryKey(),
            reflection: "schools"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school.js").default>>} */
  ensureSchoolsLoaded() {
    return this.ensureAssociationLoaded("schools")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./user-role.js").default>} */
  userRoles() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["user_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "user_roles",
        model: this,
        modelClass: UserRole
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./user-role.js").default>>} */
  loadUserRoles() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["user_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "user_roles",
        model: this,
        modelClass: UserRole
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./user-role.js").default>>} */
  ensureUserRolesLoaded() {
    return this.ensureAssociationLoaded("user_roles")
  }
}
